/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 21/4/2022
 */
import DbBaseObject from "@shared/DbBaseObject";

export default class StaticIdObject extends DbBaseObject {


	constructor() {
		super();
		this.id = null //for static id objects, id will be set from the database path itself thus it must be null or match that from the path
	}
}
